module.exports = __webpack_public_path__ + "images/39f37e152ed61fdaec6ae7f46e62ccc2.jpg";